"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/es/spin/style");
var _spin = _interopRequireDefault(require("antd/es/spin"));
require("antd/es/popover/style");
var _popover = _interopRequireDefault(require("antd/es/popover"));
require("antd/es/row/style");
var _row = _interopRequireDefault(require("antd/es/row"));
require("antd/es/tooltip/style");
var _tooltip = _interopRequireDefault(require("antd/es/tooltip"));
require("antd/es/button/style");
var _button = _interopRequireDefault(require("antd/es/button"));
require("antd/es/col/style");
var _col = _interopRequireDefault(require("antd/es/col"));
require("antd/es/modal/style");
var _modal = _interopRequireDefault(require("antd/es/modal"));
require("antd/es/message/style");
var _message2 = _interopRequireDefault(require("antd/es/message"));
var _react = _interopRequireWildcard(require("react"));
var _data = _interopRequireDefault(require("@emoji-mart/data"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _intlTools = require("@nackle/intl-tools");
var _icons = require("./shared/icons/icons.js");
var _reactColor = require("react-color");
var _html2canvas = _interopRequireDefault(require("html2canvas"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _reactFadeIn = _interopRequireDefault(require("react-fade-in"));
var _content = _interopRequireDefault(require("./content.js"));
var _ecards = _interopRequireDefault(require("./ecards.js"));
var _constants = require("./constants.js");
var _endpoints = require("./endpoints.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Picker = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require('@emoji-mart/react'))));
class Editor extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "imageLoaded", () => {
      this.setState({
        imageLoaded: true
      });
      const height = this.imageRef.current.height;
      let shiftAmount = '0px';
      if (height > 465) {
        const difference = height - 465;
        shiftAmount = `-${difference / 2}px`;
      }
      this.imageRef.current.style.transform = `translateY(${shiftAmount})`;
    });
    _defineProperty(this, "dropRejected", rejections => {
      rejections.map(rejection => {
        rejection.errors.map(error => {
          if (error.code === 'file-too-large') {
            _message2.default.error((0, _intlTools.getString)('ecard.customize.uploadTooBig'));
          }
          if (error.code === 'file-invalid-type') {
            _message2.default.error((0, _intlTools.getString)('ecard.customize.uploadUnsupportedFile'));
          }
        });
      });
    });
    _defineProperty(this, "imageDrop", files => {
      const {
        token,
        locale,
        onError
      } = this.props;
      if (files && files.length > 0) {
        this.setState({
          imageSaving: true
        });
        const type = files[0].type;
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.addEventListener('loadend', async event => {
          const saved = await (0, _ecards.default)(token, reader.result, locale);
          if (saved.errors && typeof onError === 'function') {
            onError(saved.errors);
            this.setState({
              imageSaving: false
            });
            return;
          }
          this.setState({
            selectedEcard: saved,
            showEcards: true,
            showDropzone: false,
            isUpload: true,
            imageSaving: false,
            imageType: type
          });
        }, false);
      }
    });
    _defineProperty(this, "directSelectEcard", async option => {
      await this.selectEcard(option);
      this.saveImage();
    });
    _defineProperty(this, "setEcardRef", el => {
      if (!el) {
        return;
      }
      this.ecardMessageRef = el;
      this.ecardMessageRef.focus();
    });
    _defineProperty(this, "fetchContent", async count => {
      const {
        token,
        locale
      } = this.props;
      const {
        showEcards
      } = this.state;
      const success = await (0, _content.default)(token, 'ecard-editor', locale);
      if (success.success) {
        this.setState({
          showEcards: showEcards
        });
      } else if (!success.success && parseInt(count) < 5) {
        this.fetchContent(count + 1);
      }
    });
    _defineProperty(this, "toggleEcardPicker", () => {
      const {
        onVisibilityChange
      } = this.props;
      const {
        showEcards
      } = this.state;
      this.setState({
        showEcards: !showEcards
      });
      if (typeof onVisibilityChange === 'function') {
        onVisibilityChange(!showEcards);
      }
    });
    _defineProperty(this, "selectEcard", ecard => {
      this.setState({
        selectedEcard: ecard.ecard
      });
    });
    _defineProperty(this, "deselectEcard", () => {
      const {
        setEcardImage,
        onEcardRemoved
      } = this.props;
      this.setState({
        selectedEcard: '',
        editingText: false,
        ecardText: '',
        fontFamily: 'Poppins',
        fontWeight: 600,
        backgroundColor: 'rgba(245, 247, 250, 0.5)',
        textColor: '#000000',
        imageLoaded: false,
        isUpload: false,
        saved: false
      });
      if (typeof onEcardRemoved === 'function') {
        onEcardRemoved();
      }
      setEcardImage('');
    });
    _defineProperty(this, "handleColorChange", color => {
      if (color.hex === '#f5f7fa' || color.hex === '#b1baca') {
        this.setState({
          backgroundColor: 'rgba( 0, 0, 0, 0.5 )'
        });
      } else {
        this.setState({
          backgroundColor: 'rgba(245, 247, 250, 0.5)'
        });
      }
      const originalColor = color;
      this.setState({
        textColor: color.hex,
        originalColor: originalColor
      });
    });
    _defineProperty(this, "handleBackgroundColorChange", color => {
      let textColor = '#fff';
      if (color.hex === '#f5f7fa') {
        textColor = '#000';
      }
      const originalColor = color;
      const {
        rgb
      } = color;
      if (rgb.a > 0) {
        rgb.a = 0.5;
      }
      this.setState({
        backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`,
        textColor: textColor,
        originalColor: originalColor
      });
    });
    _defineProperty(this, "trackCursor", event => {
      const cursor = this.getCaretPosition(event.target);
      this.setState({
        ecardCursor: cursor
      });
    });
    _defineProperty(this, "triggerPicker", () => {
      const {
        pickerVisible
      } = this.state;
      this.setState({
        pickerVisible: !pickerVisible
      });
    });
    _defineProperty(this, "triggerEcardEmojiPicker", () => {
      const {
        ecardEmojiPickerVisible
      } = this.state;
      this.setState({
        ecardEmojiPickerVisible: !ecardEmojiPickerVisible
      });
      setTimeout(() => {
        this.setState({
          showEcardEmojis: true
        });
        const search = document.getElementsByClassName('emoji-search');
        if (search && search.length > 0) {
          search[0].setAttribute('placeholder', (0, _intlTools.getString)('ecard.emoji.search'));
        }
      }, 100);
    });
    _defineProperty(this, "applyStyles", () => {
      const {
        branding
      } = this.props;
      setTimeout(() => {
        const containers = document.querySelectorAll('.emoji-container');
        if (containers && containers.length > 0) {
          containers.forEach(container => {
            const emojiPicker = container?.children[0]?.children[0];
            const search = emojiPicker.shadowRoot.querySelector('input[type=search]');
            if (search) {
              search.setAttribute('placeholder', (0, _intlTools.getString)('recognition.emoji.search'));
            }
            let style = document.createElement('style');
            style.innerHTML = `
                    .category .sticky,
                    .search input[type=search]::placeholder {
                        color: #727A88;
                        font-family: 'Poppins';
                        text-transform: capitalize
                    }
                    .scroll {
                        padding-right: var(--padding);
                    }
                    #nav button {
                        color: none;
                        transition: none;
                    }
                    button[aria-selected=true] svg {
                        fill: ${branding.formattedStyles.primaryColor};
                        color: ${branding.formattedStyles.primaryColor};
                    }
                    #nav .bar {
                        background-color: ${branding.formattedStyles.primaryColor};
                    }`;
            emojiPicker.shadowRoot.appendChild(style);
          });
        }
      }, 1);
    });
    _defineProperty(this, "emojiCardClick", emoji => {
      const {
        ecardCursor,
        ecardText
      } = this.state;

      // figure out how many cursor positions to move after inserting
      const emojiBits = emoji.unified.split('-');
      const bitsCount = emojiBits.length;
      const shiftOver = bitsCount * 2;
      if (!ecardText) {
        this.ecardMessageRef.innerText = `${emoji.native}`;
        this.setState({
          ecardText: `${emoji.native}`
        });
        if (emoji.unified.length > 5) {
          this.setState({
            ecardCursor: shiftOver
          });
        } else {
          this.setState({
            ecardCursor: 2
          });
        }
      } else if (ecardCursor !== undefined) {
        const messageFront = ecardText.slice(0, ecardCursor);
        const messageBack = ecardText.slice(ecardCursor);
        const updatedMessage = `${messageFront}${emoji.native}${messageBack}`;
        this.ecardMessageRef.innerText = updatedMessage;
        this.setState({
          ecardText: updatedMessage
        });
        if (emoji.unified.length > 5) {
          this.setState({
            ecardCursor: ecardCursor + shiftOver
          });
        } else {
          this.setState({
            ecardCursor: ecardCursor + 2
          });
        }
      }
    });
    _defineProperty(this, "toggleTextEdit", () => {
      const {
        editingText
      } = this.state;
      if (!editingText) {
        if (this.setEcardRef && this.setEcardRef.current) {
          this.setEcardRef.current.focus();
        }
      }
      this.setState({
        editingText: !editingText
      });
    });
    _defineProperty(this, "toggleBackground", backgroundSelected => {
      const {
        backgroundColor,
        originalColor
      } = this.state;
      if (backgroundSelected) {
        let textColor = '#ffffff';
        if (backgroundColor === 'rgba(245, 247, 250, 0.5)' && (!originalColor || originalColor.hex === '#f5f7fa')) {
          textColor = '#000000';
        }
        let rgb;
        if (originalColor) {
          rgb = originalColor.rgb;
          if (rgb.a > 0) {
            rgb.a = 0.5;
          }
        }
        if (backgroundColor === 'rgba( 0, 0, 0, 0.5 )') {
          textColor = '#000000';
        }
        this.setState({
          textBackgroundSelected: true,
          textColor: textColor,
          backgroundColor: rgb ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})` : 'rgba(245, 247, 250, 0.5)'
        });
      } else {
        let nextColor = '#ffffff';
        let newBackground = 'rgba(245, 247, 250, 0.5)';
        if (backgroundColor !== 'rgba(245, 247, 250, 0.5)') {
          nextColor = originalColor.hex;
        } else {
          nextColor = '#000000';
        }
        this.setState({
          textBackgroundSelected: false,
          textColor: nextColor,
          backgroundColor: newBackground
        });
      }
    });
    _defineProperty(this, "change", event => {
      this.setState({
        ecardText: event.target.innerText
      });
    });
    _defineProperty(this, "handleWindowMouseOrTouch", e => {
      const {
        showEcards
      } = this.state;
      if (this.popupRef && this.popupRef.current) {
        if (!this.popupRef.current.contains(e.target)) {
          this.setState({
            pickerVisible: false
          });
        }
      }
      if (this.ecardEmojiPickerRef && this.ecardEmojiPickerRef.current && showEcards) {
        if (!this.ecardEmojiPickerRef.current.contains(e.target)) {
          this.setState({
            ecardEmojiPickerVisible: false,
            showEcardEmojis: false
          });
        }
      }
    });
    _defineProperty(this, "getCaretPosition", editableDiv => {
      let caretPos = 0,
        sel,
        range;
      if (window.getSelection) {
        sel = window.getSelection();
        if (sel.rangeCount) {
          range = sel.getRangeAt(0);
          if (range.commonAncestorContainer.parentNode == editableDiv) {
            caretPos = range.endOffset;
          }
        }
      } else if (document.selection && document.selection.createRange) {
        range = document.selection.createRange();
        if (range.parentElement() == editableDiv) {
          let tempEl = document.createElement('span');
          editableDiv.insertBefore(tempEl, editableDiv.firstChild);
          let tempRange = range.duplicate();
          tempRange.moveToElementText(tempEl);
          tempRange.setEndPoint('EndToEnd', range);
          caretPos = tempRange.text.length;
        }
      }
      return caretPos;
    });
    _defineProperty(this, "changeFont", style => {
      switch (style) {
        case 'casual':
          this.setState({
            fontFamily: 'Poppins',
            fontWeight: 600
          });
          return;
        case 'formal':
          this.setState({
            fontFamily: 'Lora',
            fontWeight: 500
          });
          return;
        case 'strong':
          this.setState({
            fontFamily: 'Oswald',
            fontWeight: 600
          });
          return;
        case 'personal':
          this.setState({
            fontFamily: 'Gochi Hand',
            fontWeight: 400
          });
          return;
        case 'playful':
          this.setState({
            fontFamily: 'Pattaya',
            fontWeight: 400
          });
          return;
        default:
          this.setState({
            fontFamily: 'Poppins',
            fontWeight: 600
          });
          return;
      }
    });
    _defineProperty(this, "deletePrompt", () => {
      _modal.default.confirm({
        mask: false,
        title: /*#__PURE__*/_react.default.createElement("div", {
          className: "title-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-flex"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-circle"
        }, /*#__PURE__*/_react.default.createElement(_icons.Garbage, {
          fill: "#ffffff"
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: "title-text"
        }, this.state.saved ? 'Discard changes?' : (0, _intlTools.getString)('ecard.customize.deleteTitle'))),
        content: this.state.saved ? /*#__PURE__*/_react.default.createElement("div", {
          className: "delete-content"
        }, "Are you sure you want to discard changes?") : /*#__PURE__*/_react.default.createElement("div", {
          className: "delete-content"
        }, (0, _intlTools.getString)('ecard.customize.deleteText')),
        onOk: !this.state.saved ? () => this.deselectEcard() : () => {
          this.props.setEcardImage(this.state.savedEcard);
          this.setState({
            ecardText: '',
            fontFamily: 'Poppins',
            fontWeight: 600,
            backgroundColor: 'rgba(245, 247, 250, 0.5)',
            textColor: '#000000',
            imageLoaded: false,
            isUpload: false,
            showEcards: false,
            saved: false
          });
          this.props.onVisibilityChange(false);
        },
        okText: this.state.saved ? 'Discard' : (0, _intlTools.getString)('ecard.customize.deleteButton'),
        destroyOnClose: false,
        icon: '',
        className: 'delete-modal',
        okButtonProps: {
          danger: true
        },
        getContainer: () => this.renderRef.current
      });
    });
    _defineProperty(this, "toggleDropzone", () => {
      const {
        showDropzone,
        showEcards
      } = this.state;
      const {
        onVisibilityChange
      } = this.props;
      this.setState({
        showDropzone: !showDropzone
      });
      if (typeof onVisibilityChange === 'function') {
        if (!showEcards && !showDropzone) {
          onVisibilityChange(true);
        } else if (showDropzone && !showEcards) {
          onVisibilityChange(false);
        }
      }
    });
    _defineProperty(this, "saveImage", async () => {
      const {
        setEcardImage,
        onVisibilityChange,
        locale,
        token,
        onError,
        onSave
      } = this.props;
      const {
        selectedEcard,
        ecardText,
        textColor,
        backgroundColor,
        fontFamily,
        fontWeight,
        x,
        y
      } = this.state;
      this.setState({
        saving: true
      });
      if (ecardText && ecardText.length > 0) {
        const canvas = await (0, _html2canvas.default)(this.renderRef.current, {
          imageTimeout: 0,
          useCORS: true
        });
        const dataUrl = canvas.toDataURL('image/jpeg');
        this.setState({
          imageType: 'image/jpeg'
        });
        let originalUrl = '';
        let originalData = '';
        if (selectedEcard && selectedEcard.images && selectedEcard.images.length > 0) {
          const localeSelected = selectedEcard.images.find(image => {
            return image.locale === locale;
          });
          const fallbackSelected = selectedEcard.images.find(image => {
            return image.id === selectedEcard.defaultImageId;
          });
          if (localeSelected) {
            if (localeSelected.url) {
              originalUrl = localeSelected.url;
            } else if (localeSelected.data) {
              originalData = localeSelected.data;
            }
          } else if (fallbackSelected) {
            if (fallbackSelected.url) {
              originalUrl = fallbackSelected.url;
            } else if (fallbackSelected.data) {
              originalData = fallbackSelected.data;
            }
          }
        }
        const metadata = {
          // customText: ecardText,
          customTextStyle: {
            textColor: textColor,
            backgroundColor: backgroundColor,
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            x: x,
            y: y
          },
          stickers: [],
          originalUrl: originalUrl,
          originalData: originalData
        };
        const saved = await (0, _ecards.default)(token, dataUrl, locale, metadata);
        if (saved.errors && typeof onError === 'function') {
          onError(saved.errors);
          this.setState({
            saving: false
          });
          return;
        }
        setEcardImage(saved);
        this.setState({
          savedEcard: saved
        });
      } else {
        setEcardImage(selectedEcard);
      }
      if (typeof onSave === 'function') {
        onSave(this.state);
      }
      if (typeof onVisibilityChange === 'function') {
        onVisibilityChange(false);
      }
      this.setState({
        showEcards: false,
        saving: false,
        saved: true
      });
    });
    _defineProperty(this, "handleStop", (event, dragElement) => {
      this.setState({
        x: dragElement.x
      });
      this.setState({
        y: dragElement.y
      });
    });
    this.state = {
      showEcards: false,
      textColor: '#000000',
      pickerVisible: false,
      editingText: false,
      textBackgroundSelected: true,
      backgroundColor: 'rgba(245, 247, 250, 0.5)',
      fontFamily: 'Poppins',
      fontWeight: 600,
      showDropzone: false,
      ecardEmojiPickerVisible: false,
      showEcardEmojis: false,
      saving: false,
      imageLoaded: false,
      isUpload: false,
      imageSaving: false,
      refUpdated: false,
      saved: false,
      x: 0,
      y: 0,
      imageType: 'image/jpeg'
    };
    this.popupRef = /*#__PURE__*/_react.default.createRef();
    this.ecardMessageRef = /*#__PURE__*/_react.default.createRef();
    this.renderRef = /*#__PURE__*/_react.default.createRef();
    this.ecardEmojiPickerRef = /*#__PURE__*/_react.default.createRef();
    this.pickerButtonRef = /*#__PURE__*/_react.default.createRef();
    this.imageRef = /*#__PURE__*/_react.default.createRef();
    this.pickerRef = /*#__PURE__*/_react.default.createRef();
  }
  async componentDidMount() {
    await this.fetchContent(0);
    window.addEventListener('touchstart', this.handleWindowMouseOrTouch);
    window.addEventListener('mousedown', this.handleWindowMouseOrTouch);
    if (this.props.ecardState && this.props.ecardState.ecardText && this.props.ecardState.selectedEcard && !this.state.refUpdated) {
      this.ecardMessageRef.innerText = this.props.ecardState.ecardText;
      this.setState({
        refUpdated: true
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener('touchstart', this.handleWindowMouseOrTouch);
    window.removeEventListener('mousedown', this.handleWindowMouseOrTouch);
  }
  static getDerivedStateFromProps(props, state) {
    if (props.open === true && state.showEcards === false) {
      state.showEcards = props.open;
    }
    if (props.removeEcard && state.selectedEcard !== undefined) {
      state.selectedEcard = undefined;
      state.editingText = false;
      state.ecardText = '';
      state.fontFamily = 'Poppins', state.fontWeight = 600, state.backgroundColor = 'rgba(245, 247, 250, 0.5)', state.textColor = '#000000', state.imageLoaded = false, state.isUpload = false;
      state.saved = false;
      if (typeof props.onEcardRemoved === 'function') {
        props.onEcardRemoved();
      }
    }
    if (props.ecardState && props.ecardState.selectedEcard && !props.hideCustomization && !state.selectedEcard && !state.refUpdated) {
      state.selectedEcard = props.ecardState.selectedEcard;
      state.ecardText = props.ecardState.ecardText;
      state.fontFamily = props.ecardState.fontFamily;
      state.fontWeight = props.ecardState.fontWeight;
      state.backgroundColor = props.ecardState.backgroundColor;
      state.textColor = props.ecardState.textColor;
      state.isUpload = props.ecardState.isUpload;
    }
    return state;
  }
  render() {
    const {
      ecards,
      uploadDrawerClass,
      drawerClass,
      className,
      locale,
      companyId,
      handleKeyPress,
      hideCustomization,
      ecardRequired,
      isEditing
    } = this.props;
    const {
      showEcards,
      showDropzone,
      selectedEcard,
      textColor,
      pickerVisible,
      editingText,
      textBackgroundSelected,
      backgroundColor,
      fontFamily,
      fontWeight,
      ecardText,
      saving,
      imageLoaded,
      isUpload,
      x,
      y
    } = this.state;
    let allowUpload = false;
    let allowCustomText = false;
    if (ecards && ecards.length > 0 && ecards[0].reward) {
      allowUpload = ecards[0].reward.allowUpload;
      allowCustomText = ecards[0].reward.allowCustomText;
    }
    if (hideCustomization) {
      allowCustomText = false;
    }
    delete _data.default.emojis.middle_finger;
    let localeSelected = {};
    if (selectedEcard && !isEditing) {
      localeSelected = selectedEcard.images.find(image => {
        return image.locale === locale;
      });
      if (!localeSelected || localeSelected && !localeSelected.url) {
        localeSelected = selectedEcard.images.find(image => {
          return image.id === selectedEcard.defaultImageId;
        });
      }
    } else if (selectedEcard && isEditing) {
      localeSelected = selectedEcard.images[0];
    }
    const drawerClasses = (0, _classnames.default)({
      open: showDropzone ? false : showEcards ? true : false,
      'ecard-drawer': true,
      [drawerClass]: drawerClass ? true : false
    });
    const ecardTextClasses = (0, _classnames.default)({
      'ecard-text': true,
      'background-visible': textBackgroundSelected
    });
    const uploadDrawerClasses = (0, _classnames.default)({
      'upload-drawer': true,
      open: showDropzone,
      [uploadDrawerClass]: uploadDrawerClass ? true : false,
      'hidden': hideCustomization && !showDropzone ? true : false
    });
    const componentClasses = (0, _classnames.default)({
      'bottom-btn-container': true,
      [className]: className ? true : false
    });
    return /*#__PURE__*/_react.default.createElement(_row.default, {
      className: componentClasses
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 1
    }), /*#__PURE__*/_react.default.createElement(_col.default, {
      className: "more-container",
      md: 2,
      xs: 3
    }, !hideCustomization && (ecardRequired && !selectedEcard ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      color: 'red',
      title: (0, _intlTools.getString)('ecard.required.toolTip')
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "required"
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      tabIndex: showEcards ? -1 : 0,
      "aria-label": (0, _intlTools.getString)('ecard.imageButton.label'),
      className: "more-picker large-circle",
      shape: "circle",
      icon: /*#__PURE__*/_react.default.createElement(_icons.Image, {
        className: "image-icon"
      }),
      onClick: this.toggleEcardPicker
    })) : /*#__PURE__*/_react.default.createElement(_button.default, {
      tabIndex: showEcards ? -1 : 0,
      "aria-label": (0, _intlTools.getString)('ecard.imageButton.label'),
      className: "more-picker large-circle",
      shape: "circle",
      icon: /*#__PURE__*/_react.default.createElement(_icons.Image, {
        className: "image-icon"
      }),
      onClick: this.toggleEcardPicker
    }))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 19
    }, allowUpload && !hideCustomization && /*#__PURE__*/_react.default.createElement(_button.default, {
      tabIndex: showEcards ? -1 : 0,
      "aria-label": (0, _intlTools.getString)('ecard.uploadButton.label'),
      className: "image-upload large-circle",
      shape: "circle",
      icon: /*#__PURE__*/_react.default.createElement(_icons.Upload, null),
      onClick: this.toggleDropzone
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: drawerClasses
    }, /*#__PURE__*/_react.default.createElement(_row.default, {
      justify: "right",
      className: "title-row"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 4
    }, !hideCustomization && /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "back-btn",
      "aria-label": (0, _intlTools.getString)('ecard.backButton.label'),
      icon: /*#__PURE__*/_react.default.createElement(_icons.ArrowLeft, {
        className: "ecard-back"
      }),
      onClick: selectedEcard ? this.deletePrompt : this.toggleEcardPicker
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      className: "ecard-title-text",
      span: 15
    }, !selectedEcard && /*#__PURE__*/_react.default.createElement("h4", {
      className: "bold-header"
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.ecardSelect"
    })), selectedEcard && allowCustomText && /*#__PURE__*/_react.default.createElement("h4", {
      className: "bold-header"
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.ecardCustomize"
    }))), /*#__PURE__*/_react.default.createElement(_col.default, {
      className: "text-right",
      span: 4
    }, selectedEcard && (!hideCustomization || isUpload) && /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "save-ecard-btn primary-background",
      "aria-label": (0, _intlTools.getString)('ecard.saveButton.label'),
      loading: saving,
      shape: "round",
      onClick: () => {
        this.setState({
          editingText: false
        }, this.saveImage);
      },
      type: "primary"
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.ecardSave"
    })))), /*#__PURE__*/_react.default.createElement(_row.default, {
      justify: "center"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 24
    }, selectedEcard && /*#__PURE__*/_react.default.createElement("span", null, editingText && /*#__PURE__*/_react.default.createElement(_reactFadeIn.default, null, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-btn-container"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.casualButton.label'),
      className: "casual-btn",
      onClick: () => this.changeFont('casual')
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.casualButton"
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.personalButton.label'),
      className: "personal-btn",
      onClick: () => this.changeFont('personal')
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.personalButton"
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.strongButton.label'),
      className: "strong-btn",
      onClick: () => this.changeFont('strong')
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.strongButton"
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.formalButton.label'),
      className: "formal-btn",
      onClick: () => this.changeFont('formal')
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.formalButton"
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.playfulButton.label'),
      className: "playful-btn",
      onClick: () => this.changeFont('playful')
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.playfulButton"
    })))), localeSelected && localeSelected.url && /*#__PURE__*/_react.default.createElement("div", {
      ref: this.renderRef,
      className: "render-image"
    }, /*#__PURE__*/_react.default.createElement("img", {
      ref: this.imageRef,
      alt: "",
      crossOrigin: "anonymous",
      onLoad: this.imageLoaded,
      className: "ecard-preview",
      src: localeSelected.url
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "ecard-message-container",
      style: {
        position: 'absolute',
        width: '100%',
        top: 0,
        maxHeight: '465px',
        height: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        justifyContent: 'center',
        alignItems: 'center',
        left: 0
      }
    }, (editingText || ecardText && ecardText.length > 0) && /*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
      bounds: "parent",
      onStop: this.handleStop,
      defaultPosition: {
        x: 0,
        y: 0
      },
      position: {
        x: x,
        y: y
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: this.setEcardRef,
      onKeyUp: this.trackCursor,
      onClick: this.trackCursor,
      contentEditable: editingText,
      role: "textbox",
      onInput: this.change,
      style: {
        cursor: 'grab',
        border: 'none',
        textAlign: 'center',
        fontSize: '26px',
        minWidth: '50%',
        maxWidth: '75%',
        resize: 'none',
        borderRadius: '8px',
        padding: '12px',
        color: textColor,
        backgroundColor: backgroundColor,
        fontFamily: fontFamily || 'Poppins',
        fontWeight: fontWeight || 600
      },
      className: ecardTextClasses
    })))), /*#__PURE__*/_react.default.createElement(_row.default, {
      className: "ecard-actions"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 8
    }, editingText && /*#__PURE__*/_react.default.createElement(_reactFadeIn.default, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-tools-container"
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: textBackgroundSelected ? (0, _intlTools.getString)('ecard.customize.selectText') : (0, _intlTools.getString)('ecard.customize.selectBackground')
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "switch-container"
    }, /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
      "aria-label": `${(0, _intlTools.getString)('ecard.customize.selectText')}/${(0, _intlTools.getString)('ecard.customize.selectBackground')}`,
      borderRadius: 30,
      height: 40,
      width: 72,
      checked: textBackgroundSelected,
      onChange: this.toggleBackground,
      uncheckedHandleIcon: /*#__PURE__*/_react.default.createElement("span", {
        className: "foreground-toggle-btn"
      }, "T"),
      checkedHandleIcon: /*#__PURE__*/_react.default.createElement("span", {
        className: "background-toggle-btn"
      }, /*#__PURE__*/_react.default.createElement(_icons.RectWithT, {
        className: "background-toggle-btn"
      })),
      checkedIcon: false,
      uncheckedIcon: false,
      onColor: "#888"
    }))), /*#__PURE__*/_react.default.createElement(_popover.default, {
      overlayClassName: "color-picker-popover",
      trigger: "click",
      onClick: this.triggerPicker,
      open: pickerVisible,
      getPopupContainer: () => this.pickerButtonRef.current,
      content: /*#__PURE__*/_react.default.createElement("span", {
        ref: this.popupRef
      }, /*#__PURE__*/_react.default.createElement(_reactColor.CirclePicker, {
        color: textBackgroundSelected ? backgroundColor : textColor,
        colors: _constants.PICKER_COLORS,
        onChangeComplete: textBackgroundSelected ? this.handleBackgroundColorChange : this.handleColorChange
      }))
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: (0, _intlTools.getString)('ecard.customize.editColor')
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "color-picker-btn large-circle",
      ref: this.pickerButtonRef,
      "aria-label": (0, _intlTools.getString)('ecard.editColorButton.label'),
      shape: "circle",
      icon: /*#__PURE__*/_react.default.createElement(_icons.CircleFilled, {
        fill: textBackgroundSelected ? backgroundColor : textColor
      })
    })))))), /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 8,
      lg: 10
    }), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 2
    }, editingText && /*#__PURE__*/_react.default.createElement(_popover.default, {
      overlayClassName: "picker-popover",
      trigger: "click",
      onOpenChange: this.applyStyles,
      content: /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ecardEmojiPickerRef,
        className: "emoji-container"
      }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
        fallback: /*#__PURE__*/_react.default.createElement(_spin.default, {
          spinning: true
        })
      }, /*#__PURE__*/_react.default.createElement(Picker, {
        data: _data.default,
        ref: this.pickerRef,
        onEmojiSelect: this.emojiCardClick,
        set: 'native',
        perLine: 7,
        locale: locale ? locale.split('-')[0] : 'en',
        theme: 'light',
        navPosition: 'top',
        previewPosition: "none",
        categories: ['frequent', 'people', 'nature', 'foods', 'activity', 'places', 'objects', 'symbols', 'flags'],
        categoryIcons: _icons.customCategoryIcons
      })))
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 2
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.emojiButton.label'),
      className: "edit-text-btn large-circle",
      shape: "circle",
      icon: /*#__PURE__*/_react.default.createElement(_icons.Emoticon, null)
    })))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 2
    }, !editingText && imageLoaded && allowCustomText && /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.editTextButton.label'),
      className: "edit-text-btn large-circle",
      onClick: this.toggleTextEdit,
      shape: "circle",
      icon: /*#__PURE__*/_react.default.createElement(_icons.EditText, {
        fill: textColor
      })
    }), editingText && /*#__PURE__*/_react.default.createElement(_reactFadeIn.default, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.finishEditButton.label'),
      className: "edit-text-btn edit-text-complete large-circle",
      type: "primary",
      shape: "circle",
      onClick: this.toggleTextEdit,
      icon: /*#__PURE__*/_react.default.createElement(_icons.Checkmark, {
        fill: '#ffffff'
      })
    }))))))), /*#__PURE__*/_react.default.createElement(_row.default, {
      className: "ecard-list"
    }, !selectedEcard && allowUpload && /*#__PURE__*/_react.default.createElement(_col.default, {
      className: "ecard-image-preview",
      onKeyPress: () => handleKeyPress(event, this.toggleDropzone),
      tabIndex: selectedEcard ? -1 : 0,
      span: 4
    }, /*#__PURE__*/_react.default.createElement("div", {
      onClick: this.toggleDropzone,
      className: "select-ecard-upload"
    }, /*#__PURE__*/_react.default.createElement(_icons.Upload, {
      fill: "#3f8cff",
      className: "upload-icon"
    }))), ecards && ecards.length > 0 && !selectedEcard && ecards.map(ecard => {
      if (ecard && ecard.reward) {
        return ecard.reward.options.map(option => {
          return /*#__PURE__*/_react.default.createElement(_col.default, {
            className: "ecard-image-preview",
            onKeyPress: hideCustomization ? () => {
              handleKeyPress(event, this.directSelectEcard, option);
            } : () => handleKeyPress(event, this.selectEcard, option),
            tabIndex: selectedEcard ? -1 : 0,
            key: option.ecardId,
            span: 4
          }, /*#__PURE__*/_react.default.createElement("img", {
            alt: "",
            onClick: hideCustomization ? () => {
              this.directSelectEcard(option);
            } : () => {
              this.selectEcard(option);
            },
            className: "select-ecard",
            src: `${_endpoints.ecardUrl}/companies/${companyId}/ecards/${option.ecardId}/locales/${locale}`
          }));
        });
      }
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: uploadDrawerClasses
    }, /*#__PURE__*/_react.default.createElement(_row.default, {
      justify: "right",
      className: "title-row"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 2
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      className: "back-btn",
      "aria-label": (0, _intlTools.getString)('ecard.backButton.label'),
      icon: /*#__PURE__*/_react.default.createElement(_icons.ArrowLeft, {
        className: "ecard-back"
      }),
      onClick: this.toggleDropzone
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      className: "ecard-title-text",
      span: 17
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "bold-header"
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.upload"
    }))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 4
    }, selectedEcard && /*#__PURE__*/_react.default.createElement(_button.default, {
      "aria-label": (0, _intlTools.getString)('ecard.saveButton.label'),
      type: "primary"
    }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
      code: "ecard.customize.ecardSave"
    })))), /*#__PURE__*/_react.default.createElement(_spin.default, {
      spinning: this.state.imageSaving
    }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
      onDropRejected: this.dropRejected,
      onDrop: this.imageDrop,
      accept: 'image/*',
      multiple: false,
      maxSize: 31457280
    }, _ref => {
      let {
        getRootProps,
        getInputProps
      } = _ref;
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        className: "upload-content"
      }, getRootProps()), /*#__PURE__*/_react.default.createElement("input", _extends({
        "aria-label": (0, _intlTools.getString)('ecard.uploadInput.label'),
        style: "display: none"
      }, getInputProps())), /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-icon-container"
      }, /*#__PURE__*/_react.default.createElement(_icons.Upload, {
        fill: "#3f8cff",
        className: "upload-icon"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "upload-text-container"
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.uploadInstructions"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "parameter-text"
      }, /*#__PURE__*/_react.default.createElement(_intlTools.LocaleString, {
        code: "ecard.customize.uploadParameters"
      })))));
    }))));
  }
}
exports.default = Editor;
//# sourceMappingURL=editor.js.map